module.exports = __webpack_public_path__ + "img/mll.e75294e3.png";